export default {
    category: 'Category',
    emojis: 'Emojis',
    frequency: 'Usage Frequency',
    imageCategories: 'Image Categories',
    imageCategoryAstrology: 'Astrology',
    imageCategoryCompliments: 'Compliments',
    imageCategoryDancing: 'Dancing',
    imageCategoryDemotivational: 'Demotivational',
    imageCategoryEmoticons: 'Emoticons',
    imageCategoryFlowersAndGifts: 'Flowers & gifts',
    imageCategoryGeneral: 'General',
    imageCategoryNational: 'National',
    imageCategoryOwned: 'Owned',
    imageCategoryPeople: 'People',
    imageCategoryPersonal: 'Personal',
    imageCategoryPersonalLibrary: 'Personal Library',
    imageCategoryProfilePics: 'My Profile Images',
    imageCategoryPutDowns: 'Put downs',
    imageCategorySexy: 'Sexy',
    imageCategorySigns: 'Signs',
    images: 'Images',
    insertThisImage: 'Insert this image?',
    newest: 'Newest',
    oldest: 'Oldest',
    onlyPremiumMembersCanAddImages:
        'Only Premium Members can add images to their chat messages.',
    placeholderSearchGIF: 'Search GIF',
    recentlyUsed: 'Recently Used',
    searchEmoticon: 'Browse Emoticons',
    searchType: 'Search Type',
    shortcut: 'Shortcut',
    sortBy: 'Sort by',
    sortByFrequency: 'Usage Frequency',
    sortByNewest: 'Newest',
    sortByOldest: 'Oldest',
    sortByShortcut: 'Shortcut',
    sortByUsage: 'Total Usage',
    submittedBy: 'Submitted by',
    upload: 'Upload',
    usage: 'Total Usage',
    userName: 'Username',
}
